import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/fetch-duck";

const { Types, Creators } = createActions(
  {
    request: ["id"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "FETCH_UNIDADE_" }
);

export interface FetchUnidadeState extends IState {}

const INITIAL_STATE: FetchUnidadeState = {
  data: null,
  loading: false,
  error: null,
};

const request = (state: FetchUnidadeState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: FetchUnidadeState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: FetchUnidadeState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const fetchUnidade = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const FetchUnidadeTypes = Types;
export const FetchUnidadeActions = Creators;
